module.exports = __webpack_public_path__ + "static/media/background-2.52beb46e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/landing_images/background-2.jpeg
// module id = 1154
// module chunks = 0